// Country name → ISO 3166-1 alpha-2 code, used as the default region for
// libphonenumber-js when the user types a local-format number into the
// WhatsApp To field. Only countries the platform actively serves are
// listed; add new entries as the product expands. Keys are matched
// case-insensitively and against common spellings so that "USA",
// "United States", and "United States of America" all resolve to "US".
//
// If a country isn't in this map the WhatsApp drawer falls back to "no
// default region" — the user then has to type the number with an
// explicit `+<countrycode>` prefix, which libphonenumber will still
// parse correctly.

const ENTRIES = [
  ["IN", ["india", "ind"]],
  ["US", ["united states", "united states of america", "usa", "us", "america"]],
  ["CA", ["canada", "can"]],
  ["GB", ["united kingdom", "uk", "great britain", "britain", "england"]],
  ["AU", ["australia", "aus"]],
  ["AE", ["united arab emirates", "uae", "emirates"]],
  ["SG", ["singapore", "sgp"]],
  ["NZ", ["new zealand"]],
  ["IE", ["ireland"]],
  ["DE", ["germany"]],
  ["FR", ["france"]],
  ["PH", ["philippines"]],
  ["MY", ["malaysia"]],
  ["ZA", ["south africa"]],
];

const NAME_TO_ISO = new Map();
for (const [iso, names] of ENTRIES) {
  for (const n of names) NAME_TO_ISO.set(n, iso);
}

// Resolve a country string (name, ISO code, or common abbreviation) to
// the ISO 3166-1 alpha-2 code libphonenumber expects. Returns undefined
// when the input is empty or doesn't match a known country — callers
// should treat that as "no default region".
export const resolveCountryIso = (input) => {
  if (!input) return undefined;
  const key = String(input).trim().toLowerCase();
  if (!key) return undefined;
  // Direct ISO match (already alpha-2)
  if (key.length === 2) {
    const upper = key.toUpperCase();
    for (const [iso] of ENTRIES) if (iso === upper) return upper;
  }
  return NAME_TO_ISO.get(key);
};
